module.exports = __webpack_public_path__ + "static/media/car_portrait.64d68053.svg";